import * as React from "react";
import StandardModal from "../../Modals/StandardModal";
import FullTable from "src/components/Tables/OtherContracts/FullTableNewVersion";
import { cleanOtherContractClone } from "../../../store/leaseContracts/utils";
import { constants } from "../../../store/otherContracts";
import { setActiveFormInstance } from "../../../store/base";
import { useDispatch } from "react-redux";

export default ({ isOpen, closeFunction, onDone }) => {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const [cloneSource, setCloneSource] = React.useState(null);

  const handleRowClicked = (original) => {
    setCloneSource(original);
  };

  const checkRowHighlighted = (original) => {
    if (cloneSource?.id === original.id) return true;

    return false;
  };

  const handleCloneSourcePicked = async () => {
    const clone = await cleanOtherContractClone(cloneSource);

    dispatch(
      setActiveFormInstance({
        storeName,
        data: clone,
      })
    );

    onDone(clone, cloneSource);
  };

  return (
    <StandardModal
      {...{ isOpen, closeFunction }}
      title="Välj avtal att kopiera från"
      withActionBar
      saveFunction={handleCloneSourcePicked}
      actionBarAcceptTitle="Kopiera från valt avtal"
      canAccept={!!cloneSource}
    >
      <FullTable
        hideExport
        hideColumns
        hideTitle
        onRowClicked={handleRowClicked}
        checkRowHighlighted={checkRowHighlighted}
      />
    </StandardModal>
  );
};
